class BtCompareUtil
{
  static init() {
    BtCompareUtil.key = 'compare';
    BtCompareUtil.bubbleHtmlClass = '.compare-count-bubble';
    BtCompareUtil.maxCompareItems = 3;
    BtCompareUtil.updateCompareBubble(true);
    BtCompareUtil.loadedContent = false;
  }

  static setCompareArray(compareArray) {
    BtStorageUtil.set(BtCompareUtil.key, compareArray);
  }

  static getCompareArray() {
    return BtStorageUtil.get(BtCompareUtil.key, true) || [];
  }

  static toggleProductToCompare(productId) {
    const currentProducts = BtCompareUtil.getCompareArray();

    if (currentProducts.includes(productId) === false) {
      if (currentProducts.length >= BtCompareUtil.maxCompareItems) {
        BtCompareUtil.pushLimitMessage();
        return;
      }

      currentProducts.push(productId);

      if (typeof pushSuccessMessage === 'function') {
        pushSuccessMessage((window.addedCompareStrings && window.addedCompareStrings.success) || 'Added to compare.');
      }
    } else {
      const index = currentProducts.indexOf(productId);
      currentProducts.splice(index, 1);
    }

    BtCompareUtil.setCompareArray(currentProducts);
    BtCompareUtil.updateCompareBubble();
    BtCompareUtil.loadedContent = false;

    const popup = document.querySelector('compare-popup');
    if (popup) {
      BtCompareUtil.toogleEmptyWarningClass(popup);
    }
  }

  static removeCompareProduct(productId) {
    const currentProducts = BtCompareUtil.getCompareArray();
    const index = currentProducts.indexOf(productId);
    if (index > -1) currentProducts.splice(index, 1);

    BtCompareUtil.setCompareArray(currentProducts);
    BtCompareUtil.updateCompareBubble();

    const popup = document.querySelector('compare-popup');
    if (popup) {
      BtCompareUtil.toogleEmptyWarningClass(popup);
    }
  }

  static updateCompareBubble(ignoreZero = false) {
    const currentProducts = BtCompareUtil.getCompareArray();
    const total = currentProducts.length;

    if (total > 0 || !ignoreZero) {
      document.querySelectorAll(BtCompareUtil.bubbleHtmlClass).forEach(bubble => {
        bubble.textContent = total;
      });
      BtCompareUtil.updateAddedStyle(currentProducts);
    }

    BtCompareUtil.updateCompareButtonsState(currentProducts);
  }

  static updateAddedStyle(currentProducts = []) {
    let styleTag = document.getElementById('bt-compare-style');
    if (styleTag == undefined) {
      styleTag = document.createElement('style');
      styleTag.setAttribute('id', 'bt-compare-style');
      styleTag.textContent = BtCompareUtil.generateAddedCss(currentProducts);
      document.head.appendChild(styleTag);
    } else {
      styleTag.textContent = BtCompareUtil.generateAddedCss(currentProducts);
    }
  }

  static generateAddedCss(currentProducts = []) {
    let cssContent = '';

    // Existing "added" checkmarks
    if (currentProducts.length > 0) {
      currentProducts.forEach(productId => {
        if (cssContent !== '') cssContent += ',';
        cssContent += `.compare-add-button[data-product-id="${productId}"] .compare-added-check`;
      });
      cssContent += '{opacity:1;}';
    }

    // Visual disabled state when max reached
    cssContent += `
      .compare-add-button.is-compare-disabled button,
      compare-add-button.is-compare-disabled button {
        opacity: 0.55;
        cursor: not-allowed;
      }
    `;

    return cssContent;
  }

  static updateCompareButtonsState(currentProducts = []) {
    const reachedMax = currentProducts.length >= BtCompareUtil.maxCompareItems;

    document.querySelectorAll('compare-add-button').forEach((wrapper) => {
      const btn = wrapper.querySelector('button');
      if (!btn) return;

      const productId = btn.dataset.productId || wrapper.dataset.productId;
      const isAlreadySelected = currentProducts.includes(productId);

      // DO NOT set btn.disabled (it blocks click events entirely)
      const shouldLock = reachedMax && !isAlreadySelected;

      wrapper.classList.toggle('is-compare-disabled', shouldLock);
      btn.setAttribute('aria-disabled', shouldLock ? 'true' : 'false');
      btn.dataset.compareLocked = shouldLock ? '1' : '0';

      if (shouldLock) {
        btn.title = `You can compare up to ${BtCompareUtil.maxCompareItems} products only.`;
      } else {
        btn.removeAttribute('title');
      }
    });
  }

  static pushLimitMessage() {
    const message = `You can compare up to ${BtCompareUtil.maxCompareItems} products only.`;

    if (typeof pushErrorMessage === 'function') {
      pushErrorMessage(message);
      return;
    }
    if (typeof pushSuccessMessage === 'function') {
      pushSuccessMessage(message);
      return;
    }

    BtCompareUtil.showFallbackToast(message);
  }

  static showFallbackToast(message) {
    let toast = document.getElementById('bt-compare-limit-toast');

    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'bt-compare-limit-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.style.position = 'fixed';
      toast.style.left = '50%';
      toast.style.bottom = '24px';
      toast.style.transform = 'translateX(-50%)';
      toast.style.zIndex = '99999';
      toast.style.background = 'rgba(20,20,20,0.95)';
      toast.style.color = '#fff';
      toast.style.padding = '10px 14px';
      toast.style.borderRadius = '8px';
      toast.style.fontSize = '14px';
      toast.style.lineHeight = '1.3';
      toast.style.boxShadow = '0 6px 18px rgba(0,0,0,0.2)';
      toast.style.opacity = '0';
      toast.style.pointerEvents = 'none';
      toast.style.transition = 'opacity 180ms ease';
      document.body.appendChild(toast);
    }

    toast.textContent = message;
    toast.style.opacity = '1';

    clearTimeout(BtCompareUtil._limitToastTimer);
    BtCompareUtil._limitToastTimer = setTimeout(() => {
      if (toast) toast.style.opacity = '0';
    }, 2200);
  }

  static toogleEmptyWarningClass(popup) {
    if (!popup) return;

    const size = BtCompareUtil.getCompareArray().length;
    if (size > 1) {
      popup.classList.remove('empty', 'warning');
    } else if (size == 1) {
      popup.classList.remove('empty');
      popup.classList.add('warning');
    } else {
      popup.classList.remove('warning');
      popup.classList.add('empty');
    }
  }

  static recheckItemCount(updatedResults) {
    const updatedItemCount = parseInt(updatedResults.dataset.itemCount);
    const currentProducts = BtCompareUtil.getCompareArray();

    if (currentProducts.length > updatedItemCount) {
      const updatedItemIds = updatedResults.dataset.itemIds.split(',');
      currentProducts.forEach(productId => {
        if (!updatedItemIds.includes(productId)) {
          BtCompareUtil.removeCompareProduct(productId);
        }
      });
    }

    BtCompareUtil.updateCompareButtonsState(BtCompareUtil.getCompareArray());
  }
}

BtCompareUtil.init();

class ComparePopup extends HTMLElement
{
  constructor() {
    super();
    this.assets = document.getElementById('compare-modal-assets');
    this.results = this.querySelector('.compare-modal__results');
    this.hasAssets = false;
  }

  connectedCallback() {
    this.onSwapProductOutsideNodeHandler = this.onSwapProductOutsideNode.bind(this);
    document.addEventListener('swapProductOutsideNode', this.onSwapProductOutsideNodeHandler);
  }

  loadContent() {
    if (BtCompareUtil.loadedContent) return;

    this.classList.add('loading');
    const currentProducts = BtCompareUtil.getCompareArray();
    const newIds = [];

    currentProducts.forEach(productId => {
      newIds.push(`id:${productId}`);
    });

    const idsQuery = newIds.join(' OR ');

    fetch(`${window.routes.search_url}?section_id=product-compare&q=${idsQuery}&type="product"`)
      .then((response) => response.text())
      .then(response => {
        const html = new DOMParser().parseFromString(response, 'text/html');
        const updatedResults = html.querySelector('.results');

        if (!this.hasAssets) {
          this.assets.innerHTML = html.querySelector('.assets').innerHTML;
          this.hasAssets = true;
          HTMLUpdateUtility.reinjectsScripts(this.assets);
          this.blockTypes = updatedResults.dataset.blockTypes.split(',');
        }

        this.results.innerHTML = updatedResults.innerHTML;
        BtCompareUtil.recheckItemCount(updatedResults);
        BtCompareUtil.toogleEmptyWarningClass(this);
      })
      .finally(() => {
        this.classList.remove('loading');
        BtCompareUtil.loadedContent = true;
      });
  }

  onSwapProductOutsideNode(event) {
    const productUrl = event.detail.productUrl;

    fetch(`${productUrl}.json`)
      .then((response) => response.json())
      .then(response => {
        const productId = response.product.id;
        const requestUrl = `${window.routes.search_url}?section_id=product-compare&q=id:${productId}&type="product"`;

        const oldSectionId = event.detail.oldSectionId;
        fetch(requestUrl)
          .then((response) => response.text())
          .then(response => {
            const html = new DOMParser().parseFromString(response, 'text/html');
            const newNode = html.querySelector('product-info');
            const newSectionId = newNode.dataset.section;
            const index = event.detail.index;
            this.blockTypes.forEach((blockType) => {
              this.updateSourceFromDestination(html, oldSectionId, newSectionId, index, blockType);
            });
          });
      });
  }

  updateSourceFromDestination(html, oldSectionId, newSectionId, index, id, shouldHide = (source) => false) {
    const source = html.getElementById(`${newSectionId}-${id}-1`);
    const destination = document.getElementById(`${oldSectionId}-${id}-${index}`);
    if (source && destination) {
      if (id == 'featured_image') {
        destination.querySelector('.compare-popup__remove-link').dataset.productId = source.querySelector('.compare-popup__remove-link').dataset.productId;
      }
      destination.innerHTML = source.innerHTML;
      destination.classList.toggle('hidden', shouldHide(source));
      destination.id = `${newSectionId}-${id}-${index}`;
      if (id == 'options') {
        HTMLUpdateUtility.reinjectsScripts(destination);
      }
      if (id == 'add_to_cart') {
        destination.querySelector('product-info').dataset.index = index;
      }
    }
  }
}

customElements.define('compare-popup', ComparePopup);

class CompareAddButton extends HTMLElement
{
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    this.button = this.querySelector('button');
    this.onButtonClickHandler = this.onButtonClick.bind(this);
    this.button.addEventListener('click', this.onButtonClickHandler);

    BtCompareUtil.updateCompareButtonsState(BtCompareUtil.getCompareArray());
  }

  disconnectedCallback() {
    this.button.removeEventListener('click', this.onButtonClickHandler);
  }

  onButtonClick(e) {
    // Visual-lock mode (not real disabled)
    if (this.button.dataset.compareLocked === '1') {
      e.preventDefault();
      BtCompareUtil.pushLimitMessage();
      return;
    }

    BtCompareUtil.toggleProductToCompare(this.button.dataset.productId);
  }
}

customElements.define('compare-add-button', CompareAddButton);

class CompareRemoveButton extends HTMLElement
{
  constructor() {
    super();
    this.bindEvents();
  }

  bindEvents() {
    this.button = this.querySelector('a');
    this.onButtonClickHandler = this.onButtonClick.bind(this);
    this.button.addEventListener('click', this.onButtonClickHandler);
  }

  disconnectedCallback() {
    this.button.removeEventListener('click', this.onButtonClickHandler);
  }

  onButtonClick(e) {
    e.preventDefault();
    const popup = this.closest('compare-popup');
    BtCompareUtil.removeCompareProduct(this.button.dataset.productId);
    BtCompareUtil.toogleEmptyWarningClass(popup);

    popup.querySelectorAll(`.product-compare-${this.button.dataset.productId}`).forEach((td) => {
      td.remove();
    });
  }
}

customElements.define('compare-remove-button', CompareRemoveButton);

class CompareVariants extends HTMLElement
{
  constructor() {
    super();
    this.loadVariantPicker();
  }

  connectedCallback() {}

  loadVariantPicker() {
    fetch(`${this.dataset.url}?section_id=product-compare-item`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const variantPicker = html.getElementById(`compare-variants-${this.dataset.section}`);
        HTMLUpdateUtility.viewTransition(this, variantPicker);
      });
  }
}

customElements.define('compare-variants', CompareVariants);